import React from 'react';
import { NavLink } from 'react-router-dom';
import { getMediaPath } from 'app/functions';
import './index.scss';

const BurgerRow = ({
    id,
    icon,
    children,
    text = '',
    className = '',
    onClick = () => {},
    rightIcon,
    externalLink = '',
    internalLink = '',
}) => {
    const BurgerRowWrapper = ({ children, className, onClick, externalLink = '', internalLink = '' }) => {
        const hasExternalLink = !!externalLink;
        const hasInternalLink = !!internalLink;

        if (!hasExternalLink && !hasInternalLink) {
            return (
                <div className={className} onClick={onClick}>
                    {children}
                </div>
            );
        }

        return React.createElement(
            hasExternalLink ? 'a' : NavLink,
            hasExternalLink
                ? { className, onClick, href: externalLink, target: '_blank' }
                : { className, onClick, to: internalLink },
            children,
        );
    };

    const clickLocal = () => { 
        onClick(id, text);
    }

    return (
    <BurgerRowWrapper
        className={`burger-row ${className}`}
        onClick={clickLocal}
        externalLink={externalLink}
        internalLink={internalLink}
    >
        {children || (
            <>
                <div className="right-side">
                    {rightIcon && (
                        <div className="icon-wrapper">
                            <img src={getMediaPath(rightIcon)} alt="/" className="icon" />
                        </div>
                    )}
                    <span className='title' style={{marginRight: rightIcon ? "3.125vw":0}}>{text}</span>
                </div>
                <div className="left-side">
                    {icon && <button className="row-icon-wrapper">
                        <img src={getMediaPath(icon)} alt="/" className="icon" />
                    </button>}
                </div>
            </>
        )}
    </BurgerRowWrapper>);
}

export default BurgerRow;
